module.exports = __webpack_public_path__ + "static/img/right_logo_54x54.c4113e8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right_logo_54x54.gif
// module id = 6vaB
// module chunks = 43